class LedvibeHomeSection {
  constructor(section) {
    this.section = section;
    this.form = section.querySelector('[data-home-product-form]');

    if (!this.form) return;

    this.price = this.form.querySelector('[data-selected-price]');
    this.comparePrice = this.form.querySelector('[data-selected-compare-price]');
    this.addButton = this.form.querySelector('[data-home-add-button]');
    this.soldOutLabel = this.addButton?.dataset.soldOutLabel || 'Sold out';
    this.availableLabel = this.addButton?.dataset.availableLabel || 'Add to cart';

    this.form.addEventListener('change', this.handleVariantChange);
  }

  handleVariantChange = (event) => {
    const input = event.target.closest('input[name="id"]');
    if (!input) return;

    const available = input.dataset.available === 'true';
    const comparePrice = input.dataset.comparePrice;

    if (this.price) this.price.textContent = input.dataset.price || '';

    if (this.comparePrice) {
      this.comparePrice.textContent = comparePrice || '';
      this.comparePrice.hidden = !comparePrice || comparePrice === input.dataset.price;
    }

    if (this.addButton) {
      this.addButton.disabled = !available;
      this.addButton.textContent = available ? this.availableLabel : this.soldOutLabel;
    }
  };
}

const initializeLedvibeHomeSections = (root = document) => {
  root.querySelectorAll('[data-ledvibe-home]').forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    new LedvibeHomeSection(section);
  });
};

initializeLedvibeHomeSections();
document.addEventListener('shopify:section:load', (event) => initializeLedvibeHomeSections(event.target));
